export enum EPortals {
  bk_homeaway = 'https://channelmanager.avantio.com/assets/logos/med/homeaway.png',
  bk_expedia = 'https://channelmanager.avantio.com/assets/logos/med/expedia.png',
  bk_bookingcom = 'https://channelmanager.avantio.com/assets/logos/med/booking.png',
  bk_holidu = 'https://channelmanager.avantio.com/assets/logos/med/holidu.png',
  bk_hometogo = 'https://channelmanager.avantio.com/assets/logos/med/hometogo.png'
}
